import { openobserveLogs } from '@openobserve/browser-logs';

/**
 * Manual logger that ships structured logs to the O2 logs stream
 * (same wrapper shape as the poc-rum demo's `rumLogger`).
 *
 * openobserveLogs is initialized by OpenObserveProvider; calls made before
 * init are buffered by the SDK, and failures never break the app.
 */
export const rumLogger = {
	info: (message: string, context?: Record<string, unknown>) => {
		try {
			openobserveLogs.logger.info(message, context);
		} catch (error) {
			console.error('OpenObserve: Failed to send info log', error);
		}
	},
	warn: (message: string, context?: Record<string, unknown>) => {
		try {
			openobserveLogs.logger.warn(message, context);
		} catch (error) {
			console.error('OpenObserve: Failed to send warn log', error);
		}
	},
	error: (message: string, context?: Record<string, unknown>, error?: Error) => {
		try {
			openobserveLogs.logger.error(message, context, error);
		} catch (loggerError) {
			console.error('OpenObserve: Failed to send error log', loggerError);
		}
	},
};
